<template>
	<div class="goods" @click="showDtl">
		<meta name="referrer" content="origin">
		<meta name="referrer" content="origin-when-cross-origin">
		<meta name="referrer" content="same-origin">
		<meta name="referrer" content="no-referrer" />
		<div class="goods-img">
			<span></span>
			<img :src="data.product_img" />
		</div>

		<div class="goods-right">
			<div class="title">{{ data.product_name }}</div>
			<div class="bottom">
				<div class="price">￥{{ data.price / 100}}</div>
				<div class="add">
					<img src="~@/assets/group_order_add_green.png" />
					<!-- <stepper :min="0" :v-model="num" disable-input></stepper> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import pageevent from "./event";
	import {
		getGoodsInfo2
	} from "@/api";

	export default {
		props: ["data"],
		data() {
			return {
				num: 0,
			};
		},
		methods: {
			showDtl() {
				getGoodsInfo2(this.data["product_id"]).then((d) => {
					var cd = d.data.customization_data || {};
					var customizations = cd["customizations"];
					// 如果数组为空直接添加到购物车
					if (customizations && JSON.stringify(customizations) !== "[]") {
						pageevent.$emit("showGoodsDtl", this.data, d.data);
					} else {
						var mapping = d.data["coffee_sku_mapping"] || {};
						var keys = Object.keys(mapping);
						var first = keys.length > 0 ? mapping[keys[0]] : {};
						this.$store.dispatch('addShoppingCart', {
							qty: 1,
							id: first.id || cd.id,
							sku: first.sku_id || cd.sku,
							spec_id: first.id || cd.id,
							spec_sku: first.sku_id || cd.sku,
						}).then(() => {
							pageevent.$emit("addCartSuccess", this.data);
						})
					}
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.goods {
		display: flex;
		padding: 0 20px;

		.goods-img {
			width: 200px;
			height: 200px;
			position: relative;

			&>* {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}

			&>img {
				object-fit: contain;
			}

			&>span {
				width: 164px;
				height: 164px;
				left: 50%;
				top: 50%;
				background: rgb(216, 219, 60);
				border-radius: 50%;
				transform: translate(-50%, -50%);
			}
		}

		.goods-right {
			flex: 1;
			padding: 20px 0;
			padding-left: 20px;
			display: flex;
			flex-direction: column;

			.title {
				flex: 1;
				font-size: 28px;
			}

			.bottom {
				font-size: 28px;
				display: flex;
				justify-content: space-between;
				align-self: content;

				.price {
					font-weight: bold;
					font-size: 28px;
				}

				.add {
					width: 50px;
					height: 50px;
					font-size: 0;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
	}
</style>